export const COMPANY = {
  name: "RevMatrix",
  tagline: "Lead generation, in plain English.",
  phone: "+1-778-350-7746",
  phoneDisplay: "+1 (778) 350-7746",
  phoneHref: "tel:+17783507746",
  email: "curtis@revmatrix.ca",
  emailHref: "mailto:curtis@revmatrix.ca",
  location: "Victoria, British Columbia, Canada",
  locationShort: "Victoria, B.C.",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_growth-consulting-hq/artifacts/93sqq0k8_ChatGPT%20Image%20Apr%2030%2C%202026%2C%2010_21_03%20AM.png",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    id: "facebook",
    platform: "Facebook",
    title: "Facebook Ads",
    iconKey: "facebook",
    description:
      "Reach the right people on Facebook with ads built to bring in new customers and win back past ones.",
    highlights: [
      "Both automated and hand-tuned campaigns",
      "Lots of ad ideas tested side-by-side",
      "Tracking that shows what's really working",
    ],
  },
  {
    id: "instagram",
    platform: "Instagram",
    title: "Instagram Ads",
    iconKey: "instagram",
    description:
      "Turn scrollers into customers with eye-catching ads in Stories, Reels, and the main feed.",
    highlights: [
      "Short-video ads built for Reels",
      "Story ads that follow up over time",
      "Working with creators to make your ads",
    ],
  },
  {
    id: "tiktok",
    platform: "TikTok",
    title: "TikTok Ads",
    iconKey: "tiktok",
    description:
      "Ads that look like real TikToks — built to blend in, ride the algorithm, and reach a younger audience.",
    highlights: [
      "Real-feeling videos that fit the feed",
      "Lots of new videos tested every week",
      "Reaching younger buyers where they hang out",
    ],
  },
  {
    id: "youtube",
    platform: "YouTube",
    title: "YouTube Ads",
    iconKey: "youtube",
    description:
      "Short and long video ads on YouTube — putting your story in front of the right viewers, profitably.",
    highlights: [
      "Pre-roll, in-feed, and Shorts placements",
      "Tracking views that turn into sales",
      "Follow-up ads to people who watched",
    ],
  },
  {
    id: "snapchat",
    platform: "Snapchat",
    title: "Snapchat Ads",
    iconKey: "snapchat",
    description:
      "An overlooked channel where ads still cost less and a younger audience actually pays attention.",
    highlights: [
      "Interactive filter and lens ads",
      "Ads in Stories and the Discover feed",
      "Tracking that helps target the right people",
    ],
  },
  {
    id: "google",
    platform: "Google",
    title: "Google Ads",
    iconKey: "google",
    description:
      "Catch people right when they're searching for what you offer — Search, automated campaigns, and YouTube.",
    highlights: [
      "Search ads + Google's automated campaigns",
      "Sales tracking set up properly",
      "Product listings on Google Shopping",
    ],
  },
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Discovery Call",
    description:
      "Free 30-minute chat. We learn your business, your goals, and what's slowing your growth.",
  },
  {
    step: "02",
    title: "Audit & Plan",
    description:
      "We look at what you're doing today, study your competition, and build a clear plan to bring in more leads.",
  },
  {
    step: "03",
    title: "Launch & Improve",
    description:
      "Ads go live and we test different versions. Every week we tweak based on what's actually bringing in leads.",
  },
  {
    step: "04",
    title: "Scale & Report",
    description:
      "When something's working, we put more behind it. You'll see exactly where every dollar went — and what it brought back.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "RevMatrix rebuilt our Facebook ads from scratch. Within 90 days our cost per lead dropped 38% and we tripled our ad spend — without losing money on a single campaign.",
    author: "Jordan Wei",
    role: "Founder, Northbay Apparel",
  },
  {
    quote:
      "Curtis treats our budget like it's his own. The weekly improvements and ad ideas are the sharpest we've seen after working with four different agencies.",
    author: "Priya Sandhu",
    role: "Head of Growth, Coastline DTC",
  },
  {
    quote:
      "The consulting paid for itself in the first month. Clear, no-fluff, and they actually understand what's driving sales — not just clicks.",
    author: "Marcus Fenn",
    role: "CEO, Lumen Supplements",
  },
  {
    quote:
      "We were intimidated by TikTok. RevMatrix handled the videos, the ads, and the reporting — it's now our second biggest source of new customers.",
    author: "Avery Chen",
    role: "Marketing Director, Harbour Studio",
  },
];

export const STATS = [
  { value: "$50M+", label: "Ad Spend Managed" },
  { value: "2.0x", label: "Sales For Every $1 Spent" },
  { value: "24/7", label: "AI-Powered Optimization" },
  { value: "90 Days", label: "To See Real Results" },
];

export const BUDGET_OPTIONS = [
  "Under $5k / month",
  "$5k – $15k / month",
  "$15k – $50k / month",
  "$50k+ / month",
  "Consulting only",
  "Not sure yet",
];
